/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/orbital_defense': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M22.326 15.826A6.333 6.333 0 0016 9.5a6.333 6.333 0 00-6.326 6.326c0 3.361 2.639 6.111 5.954 6.307V25.5h.744v-3.367c3.316-.195 5.954-2.945 5.954-6.307zm-5.954 5.563v-4.127a1.483 1.483 0 001.116-1.436 1.489 1.489 0 00-2.976 0c0 .691.476 1.27 1.116 1.436v4.127c-2.904-.193-5.209-2.611-5.209-5.563 0-3.078 2.504-5.582 5.582-5.582s5.582 2.504 5.582 5.582c-.001 2.951-2.308 5.367-5.211 5.563z"/>'
  }
})
